import { Alert, Card } from '@zillow/constellation-10';
import type { YourRentalErrorDto } from '@zg-rentals/ts-your-rental-api-client';
import TransactionsTableHeader from './TransactionsTableHeader';

type TransactionsTableErrorProps = {
  error: YourRentalErrorDto;
};

const TransactionsTableError = ({ error }: TransactionsTableErrorProps) => {
  return (
    <Card
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '{spacing.default} {spacing.loose} {spacing.loose}',
      }}
      data-testid="RentReporting-TransactionsTableDesktop"
    >
      <TransactionsTableHeader headerText={error.transactionHeaderText} />
      <Alert tone="critical" css={{ width: '100%', marginTop: '{spacing.default}' }}>
        {error.message}
      </Alert>
    </Card>
  );
};

TransactionsTableError.displayName = 'TransactionsTableError';

export default TransactionsTableError;
